<template>
  <div id="app">
    <div id="nav" v-if="showNav">
      <b-navbar toggleable="md" type="light" variant="white" placement="fixed">
        <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>

        <b-navbar-brand to="/">
          <img
            :src="BASE_URL + 'assets/images/logo_' + BRAND + '.png'"
            :alt="BRAND"
            style="height:50px;"
          />
        </b-navbar-brand>

        <b-collapse is-nav id="nav_collapse">
          <!-- Right aligned nav items -->
          <b-navbar-nav class="ml-auto">
            <template v-if="BRAND == 'IM'">
              <b-nav-item to="/orders">Orders</b-nav-item>
              <b-nav-item to="/stock">Stock</b-nav-item>
              <b-nav-item to="/packages">Packages</b-nav-item>
              <b-nav-item to="/dispatch">Dispatch</b-nav-item>
              <b-nav-item to="/payments">Payments</b-nav-item>
              <b-nav-item to="/shipments">Shipments</b-nav-item>
              <b-nav-item to="/ingredients">Ingredients</b-nav-item>
              <b-nav-item to="/raw/shipments">Raw Shipments</b-nav-item>
              <b-nav-item to="/testing/requests">Testing Requests</b-nav-item>
              <b-nav-item to="/envelopes">Envelopes</b-nav-item>
            </template>

            <template v-if="BRAND == 'SM'">
              <b-nav-item to="/orders">Orders</b-nav-item>
              <b-nav-item to="/stock">Stock</b-nav-item>
              <b-nav-item to="/packages">Packages</b-nav-item>
              <b-nav-item to="/dispatch">Dispatch</b-nav-item>
              <b-nav-item to="/shipments">Shipments</b-nav-item>
              <b-nav-item to="/ingredients">Ingredients</b-nav-item>
              <b-nav-item to="/raw/shipments">Raw Shipments</b-nav-item>
              <b-nav-item to="/testing/requests">Testing Requests</b-nav-item>
              <b-nav-item to="/envelopes">Envelopes</b-nav-item>
            </template>

            <template v-if="BRAND == 'VM'">
              <!-- <b-nav-item to="/orders">Orders</b-nav-item> -->
              <b-nav-item to="/stock">Stock</b-nav-item>
              <!-- <b-nav-item to="/packages">Packages</b-nav-item> -->
              <!-- <b-nav-item to="/dispatch">Dispatch</b-nav-item> -->
            </template>

            <template v-if="BRAND == 'EB'">
              <b-nav-item to="/orders">Orders</b-nav-item>
              <b-nav-item to="/mappings">Mappings</b-nav-item>
              <b-nav-item to="/dispatch">Dispatch</b-nav-item>
            </template>

            <template v-if="BRAND == 'FF'">
              <b-nav-item to="/orders">Orders</b-nav-item>
              <b-nav-item to="/stock">Stock</b-nav-item>
              <b-nav-item to="/packages">Packages</b-nav-item>
              <b-nav-item to="/shipping">Shipping</b-nav-item>
              <b-nav-item to="/dispatch">Dispatch</b-nav-item>
            </template>

            <b-nav-item-dropdown text="Brand" right>
              <b-dropdown-item @click="changeBrand('IM')"
                >Intellimeds</b-dropdown-item
              >
              <b-dropdown-item @click="changeBrand('SM')"
                >SportsMeds</b-dropdown-item
              >
              <b-dropdown-item @click="changeBrand('VM')"
                >VitaMeds</b-dropdown-item
              >
              <b-dropdown-item @click="changeBrand('FF')"
                >FortFitness</b-dropdown-item
              >
              <b-dropdown-item @click="changeBrand('EB')">Ebay</b-dropdown-item>
            </b-nav-item-dropdown>
            <b-nav-item-dropdown
              right
              :text="user.username"
              style="text-transform:capitalize;"
            >
              <b-dropdown-item @click="logout">Logout</b-dropdown-item>
            </b-nav-item-dropdown>
          </b-navbar-nav>
        </b-collapse>
      </b-navbar>
    </div>
    <div class="container-fluid">
      <router-view />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showNav: localStorage.getItem("user") ? true : false,
      user: localStorage.getItem("user")
        ? JSON.parse(localStorage.getItem("user"))
        : null
    };
  },
  methods: {
    logout() {
      localStorage.removeItem("user");
      localStorage.removeItem("jwt");
      this.$router.push("/login");
      this.showNav = false;
    },
    changeBrand(brand) {
      localStorage.setItem("brand", brand);
      window.location.href = "/";
    }
  }
};
</script>
